var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { PublicDataContext } from './PublicDataContext';
// Later it can be passed into a hook as `usePublicData(scope)`
var defaultScope = 'component';
var PublicDataProviderViewer = /** @class */ (function (_super) {
    __extends(PublicDataProviderViewer, _super);
    function PublicDataProviderViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleGetParam = function (key, scope) {
            if (scope === void 0) { scope = defaultScope; }
            try {
                return _this.props.data[scope][key];
            }
            catch (e) {
                console.error("key \"" + key + "\" wasn't found on public data:");
                console.error(e);
                return undefined;
            }
        };
        _this.state = {
            value: {
                get: _this.handleGetParam,
                set: function () {
                    throw new Error("You can't edit settings from the Widget");
                },
                reset: function () {
                    throw new Error("You can't edit settings from the Widget");
                },
                ready: true,
                readyPromise: Promise.resolve(true),
                type: 'viewer-public-data',
            },
        };
        return _this;
    }
    PublicDataProviderViewer.prototype.render = function () {
        return (React.createElement(PublicDataContext.Provider, { value: this.state.value }, this.props.children));
    };
    return PublicDataProviderViewer;
}(React.Component));
export { PublicDataProviderViewer };
//# sourceMappingURL=PublicDataProviderViewer.js.map